import { useSelector } from 'react-redux';
import Profile from 'components/Profile';
import { Buttons, ButtonLink } from 'ui';
import { getContact } from 'api/contacts';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

const ContactDetails = ({ id }) => {
  const { t } = useTranslation('profile');

  const placeId = useSelector(state => state.ui.selectedPlaceId);
  const isImpersonating = useSelector(state =>
    Boolean(state.user.impersonatedUser),
  );

  const params = { placeId };

  const { data: contactData } = useQuery(['contacts', id, params], getContact);
  const contact = contactData?.data;

  return (
    <>
      <Profile user={contact} readOnly />

      {contact?.canTalk && !isImpersonating && (
        <Buttons>
          <ButtonLink
            isPrimary
            to={{
              pathname: '/mes-echanges/mes-messages/nouveau',
              state: {
                reset: true,
                members: [
                  { id: contact?.id, displayName: contact?.displayName },
                ],
              },
            }}
          >
            {t('contactDetails:sendMessage')}
          </ButtonLink>
        </Buttons>
      )}
    </>
  );
};

export default ContactDetails;
